export const arrayAndObjectLevelConstants = {
    financierIds: {
        dev: {
            tmf: "a00fde2c-ba5d-41fd-a4f9-7a4ef9f61e06",
            sbi: "f8bb8f36-6614-4a09-8561-d1313796690e",
            chola: "8f3db377-7cb0-4690-b8d8-d75af3bac480",
            hdfc: "6b713560-0a14-46a7-8de1-4e5709071705",
            sundaram: "b6c30009-7652-4a42-887c-751168563160",
            hdbfs: "acb367ad-e122-4300-b6a4-85043b110cca",
            yesBank: "f25c41b0-08a1-4f0b-9491-10e63891faaf",
            equitas:"00ed7c72-9078-47e3-81aa-fd8ce5de4bef",
            auFinance:"106fd52a-42d3-4123-a7c6-3b2154d34a27",
            idfcFinance:"5c8bc2a1-e01a-4d1b-8295-c2fff0e2059b",
            kotak:"ab1c6b17-e2f7-4d86-a32b-57fb4c33d1ab"

        },
        qa: {
            tmf: "a00fde2c-ba5d-41fd-a4f9-7a4ef9f61e06",
            sbi: "f8bb8f36-6614-4a09-8561-d1313796690e",
            chola: "8f3db377-7cb0-4690-b8d8-d75af3bac480",
            hdfc: "578695c6-30df-472a-bcfa-345abe3a0744",
            sundaram: "b6c30009-7652-4a42-887c-751168563160",
            hdbfs: "acb367ad-e122-4300-b6a4-85043b110cca",
            yesBank: "f25c41b0-08a1-4f0b-9491-10e63891faaf",
            equitas:"00ed7c72-9078-47e3-81aa-fd8ce5de4bef",
            auFinance:"106fd52a-42d3-4123-a7c6-3b2154d34a27",
            idfcFinance:"5c8bc2a1-e01a-4d1b-8295-c2fff0e2059b"

        },
        production: {
            tmf: "bd6a7ace-0f92-4bfa-a282-f8dc9a15a717",
            sbi: "8dfa5931-629e-4919-8f38-7624029f2299",
            chola: "8f3db377-7cb0-4690-b8d8-d75af3bac480",
            hdfc: "04563382-81bb-4b57-9e47-5db3a73a738a",
            sundaram: "02d02bbf-1489-4b1b-8d4c-2b3bd16436d8",
            hdbfs: "eb43e417-f3eb-4f20-9eb8-3ef99c5765dc",
            yesBank: "41a9ca18-d3f0-4e3d-a9af-72cc60d5ae6b",
            idfcFinance:"7fc565b8-7565-41c4-8524-24e57af88160", 
            equitas:"d1f9df98-6be4-4c23-913b-3c29ad2088a7",
            kotak:"758c84fc-1a7f-4e57-901a-5d8315455da9",
            auFinance:"9ab20115-4026-4c37-a7ab-3eb625d0b8fa"
        }
    },
}
